// extracted by mini-css-extract-plugin
export default {"Error":"InputError_Error__jQo0l","ErrorIcon":"InputError_ErrorIcon__-jY7X","ErrorText":"InputError_ErrorText__bj2Ks"};